// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"576":"4572f2c7","898":"182480a8"}[chunkId] + ".chunk.css";
};